module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":{"label":"Email","placeholder":"Email"},"password":{"label":"Password","placeholder":"Password"}},"ua":{"email":{"label":"Email","placeholder":"Email"},"password":{"label":"Пароль","placeholder":"Пароль"}},"ru":{"email":{"label":"Email","placeholder":"Email"},"password":{"label":"Пароль","placeholder":"Пароль"}}}')
  delete Component.options._Ctor
}
